import React, { useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import { HiInformationCircle } from "react-icons/hi2";
import { assignGlossaryPortalAction, portalDropDownAction } from "../../redux/actions/resourceAction";
import errorToast from "../../components/toast/errorToast";
import { useDispatch } from "react-redux";
import successToast from "../../components/toast/successToast";

const AssignToPortal = ({ show, onHide, selectedResources, reloadData }) => {

  const [portalData, setportalData] = useState([]);
  const [selectedPortals, setSelectedPortals] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(portalDropDownAction({}, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setportalData(data.data.data);
  };

  const onError = (data) => {
    errorToast(data.data.message)
  };

  const handlePortalSelect = (e) => {
    const { value } = e.target
    setSelectedPortals([value]);
  }

  const handleAssign = () => {
    const data = {
      glossaries: selectedResources,
      portals: selectedPortals
    }
    dispatch(assignGlossaryPortalAction(data, onAssignSuccess, onError))
  }

  const onAssignSuccess = (data) => {
    successToast(data.data.message);
    onHide();
    reloadData();
  }

  return (
    <>
      <Offcanvas
        show={show}
        onHide={onHide}
        placement="end"
        style={{ width: "600px" }}
        backdrop="static"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Assign resource to portal</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <h5>Select Portals</h5>
            <div className="grayheader d-flex">
              <HiInformationCircle className="d-flex  gap-3 mr-1" style={{ fontSize: "3rem" }} />
              <p className="mb-1 gap-3">
                If resources are already been assigned to some of the
                portals, no change will be made.  Only Glossaries
                can be assigned to BASIC portal, other resources  can not be assigned to BASIC portal
              </p>
            </div>
            <div>
              <Form>
                <Form.Group controlId="glossaryType">
                  <Form.Label>Portals</Form.Label>
                  <Form.Select onChange={handlePortalSelect}>
                    <option key={"portal"} value={''}>Select portal</option>
                    {portalData?.map((portal) => (
                      <option key={portal.id} value={portal.id}>
                        {portal.portal_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Form>
            </div>
          </div>
          <div className="d-flex gap-4 mt-4 px-4">
            <button
              type="button"
              className="btn btn-primary btn-action"
              onClick={handleAssign}
            >
              ASSIGN
            </button>
            <button type="button" className="btn btn-primary" onClick={onHide}>
              Cancel
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AssignToPortal;
